import { z } from 'zod';

import {
    canonicalServiceTypes,
    serializeServiceOrderStopName,
    serviceOrderStopNameSeparator,
} from '#domain/serviceOrderStopName.ts';

import { error, StopFormDataValidationSchema } from './OrderFormValidation.ts';

const SERVICE_ORDER_TEXT_MAX_LENGTH = 255;

export const ServiceOrderFormSchema = z
    .object({
        serviceType: z.enum([...canonicalServiceTypes, 'other']),
        otherType: z.string().max(SERVICE_ORDER_TEXT_MAX_LENGTH, error.LONG_STRING).optional(),
        company: z.string().max(SERVICE_ORDER_TEXT_MAX_LENGTH, error.LONG_STRING).optional(),
        description: z.string().min(1, error.SMALL_STRING).max(SERVICE_ORDER_TEXT_MAX_LENGTH, error.LONG_STRING),
        note: z.string().max(SERVICE_ORDER_TEXT_MAX_LENGTH, error.LONG_STRING).optional(),
        executionStop: StopFormDataValidationSchema,
    })
    .refine(data => data.serviceType !== 'other' || Boolean(data.otherType?.trim()), {
        message: error.SMALL_STRING,
        path: ['otherType'],
    })
    .refine(data => data.serviceType !== 'other' || !data.otherType?.includes(serviceOrderStopNameSeparator), {
        message: error.LONG_STRING,
        path: ['otherType'],
    })
    .refine(
        data => {
            const serviceType = data.serviceType === 'other' ? (data.otherType ?? '') : data.serviceType;
            return serializeServiceOrderStopName(serviceType, data.company).length <= SERVICE_ORDER_TEXT_MAX_LENGTH;
        },
        {
            message: error.LONG_STRING,
            path: ['company'],
        }
    );

export type ServiceOrderFormData = z.infer<typeof ServiceOrderFormSchema>;
